import type { SetPreferredFreelancersOnlyRequestAjax } from './set-preferred-freelancers-only.backend-model';
import type { SetPreferredFreelancersOnly } from './set-preferred-freelancers-only.model';

export function transformSetPreferredFreelancersOnly(
  item: SetPreferredFreelancersOnlyRequestAjax,
): SetPreferredFreelancersOnly {
  return {
    id: item.projectId,
    action: item.action,
  };
}
